// extracted by mini-css-extract-plugin
export default {"mainContainer":"SliderButton_mainContainer__hoet+","arrowContainer":"SliderButton_arrowContainer__1fGz4","sliderText":"SliderButton_sliderText__b4RUw"};